import React from "react";
import { QueryInterestProfile } from "types/gql-types";
import { getLanguageNameByCode } from "pages/dashboard/utils";
import PhoneNumber from "components/phone-number/phone-number";
import styles from "../details.module.css";
import Heading from "./heading";
import Row from "./row";
import InterestAddress from "./interest-address";
type Interest = NonNullable<QueryInterestProfile["interest"]>;

// @ts-ignore
const getPhoneType = (interest: Interest): string => ({
  landline: "Landline",
  mobile: "Mobile",
}[`${interest.householdMember0PrimaryPhoneType}`] ?? "Phone number");


const displayMailingAddress = (interest: Interest): React.ReactNode => {
  if (interest.mailingAddressType === "residence") return "Use residence address";
  return <InterestAddress interest={interest} prefix="mailing"/>;
};

const ContactInformation: React.FC<{interest: Interest}> = ({ interest }) => {
  const firstName = interest.householdMember0FirstName || interest.applicantFirstName;
  const lastName = interest.householdMember0LastName || interest.applicantLastName;
  const primaryPhone = interest.householdMember0PrimaryPhone || interest.applicantPhonePrimary;
  const secondaryPhone = interest.householdMember0SecondaryPhone ||
    interest.applicantPhoneSecondary;
  const secondaryExt = interest.householdMember0SecondaryPhoneExt ||
    interest.applicantPhoneSecondaryExt;
  const email = interest.householdMember0Email || interest.applicantEmail;

  return (
    <div className={styles.group}>
      <Heading text="Contact Information" />
      <Row title="Name">
        {[firstName, lastName].filter(Boolean).join(" ")}
        {interest.prefLang && interest.prefLang !== "en" && (
          <span className="badge hc-badge">{getLanguageNameByCode(interest.prefLang)}</span>
        )}
      </Row>
      <Row title={getPhoneType(interest)}>
        {primaryPhone && <PhoneNumber number={primaryPhone} />}
      </Row>
      <Row title="Secondary">
        {secondaryPhone && <PhoneNumber number={secondaryPhone} ext={secondaryExt} />}
      </Row>
      <Row title="Email">{email}</Row>
      <Row title="Residence"><InterestAddress interest={interest} prefix="residence" /></Row>
      <Row title="Mailing">{displayMailingAddress(interest)}</Row>
    </div>);
};
export default ContactInformation;
